import { Stack, Text, Title } from "@mantine/core";
import { AppWebviewLayout } from "./AppWebviewLayout";
import { AppWebviewButton } from "./AppWebviewButton";
import errorIllustrationUrl from "../../assets/sambla-error-illustration.svg?url";
import classes from "./appWebviewShared.module.css";

interface ErrorScreenProps {
  onRetry: () => void;
  isRetrying?: boolean;
}

export function ErrorScreen({ onRetry, isRetrying }: ErrorScreenProps) {
  return (
    <AppWebviewLayout
      fillBody
      footer={
        <AppWebviewButton
          size="lg"
          onClick={onRetry}
          loading={isRetrying}
          rightSection={false}
        >
          Försök igen
        </AppWebviewButton>
      }
    >
      <Stack role="alert" gap="xl" align="center" className={classes.content}>
        <img src={errorIllustrationUrl} alt="" className={classes.doorIcon} />

        <Stack gap="sm" align="center">
          <Title
            order={1}
            fz="h2"
            lh="h2"
            ff="var(--wallet-font-family-sambla-sans)"
            ta="center"
          >
            Något gick fel...
          </Title>
          <Text
            c="dimmed"
            size="sm"
            lh={1.6}
            ta="center"
            ff="var(--wallet-font-family-sambla-sans)"
          >
            Vänligen försök igen. Kontakta kundtjänst om problemet kvarstår.
          </Text>
        </Stack>
      </Stack>
    </AppWebviewLayout>
  );
}
